export const INPUT_ERROR = "input-error";

export const MIN_SLIDES_TO_SHOW_ARROWS_ON_DESKTOP = 4;

export const COUPON_VIEW_KEY = 'event-coupon-key-';
export const PROVINCE_SELECTED: string = 'province_selected';

export enum pagesEnum {
    CONTEST,
    HOME,
    SUBSCRIBE,
    CREATE_CARD,
    COUPONS,
    PROFIL_ACCOUNT,
    PROFIL_CARD,
    PROFIL_HISTORY,
    PROFIL_PREFERENCES,
    PROFIL,
    SUBSCRIBE_WELCOME,
    FAQ,
    PRIVILEGES,
    LINK_CARD,
    DASHBOARD,
    ERROR_500
}

export const URLS =
    {
        CONTEST: {fr: '/concours', en: '/en/contests'},
        HOME: {fr: '/accueil', en: '/en/home'},
        SUBSCRIBE: {fr: '/adhesion', en: '/en/subscribe'},
        CREATE_CARD: {fr: '/adhesion/create', en: '/en/subscribe/creation'},
        COUPONS: {fr: '/coupons', en: '/en/profile/coupons'},
        PROFIL_ACCOUNT: {fr: '/profil/compte', en: '/en/account/profile'},
        PROFIL_CARD: {fr: '/profil/cartes', en: '/en/account/cards'},
        PROFIL_HISTORY: {fr: '/profil/historique', en: '/en/account/history'},
        PROFIL_PREFERENCES: {fr: '/profil/preferences', en: '/en/account/preferences'},
        PROFIL: {fr: '/profil', en: '/en/account'},
        SUBSCRIBE_WELCOME: {fr: '/bienvenue', en: '/en/welcome'},
        FAQ: {fr: '/centre-aide', en: '/en/help-center'},
        PRIVILEGES: {fr: '/mes-privileges', en: '/en/my-privileges'},
        LINK_CARD: {fr: '/liaison', en: '/en/link'},
        DASHBOARD: {fr: '/tableau-de-bord', en: '/en/dashboard'},
        ERROR_500: {fr: '/erreur/500', en: '/en/error/500'},
    }

export const LINK_CARD_STEP = {
    API_ERROR: "-2",
    ERROR_IN_VALIDATION: "-1",
    SUCCESS: "0",
    CARD_NUMBER: "1",
    POSTAL_CODE: "2"
}
export const NUMBER_OF_CARDS_ON_LOAD = 12;
export const NUMBER_OF_CARDS_ON_FIRST_CLICK = 24;
export const NUMBER_OF_CARDS_ON_SECOND_CLICK = -1;

export const NUMBER_TRANSACTIONS_TO_DISPLAY = 30;
export const LAST_DAYS_TO_DISPLAY = "30";

export const CYBERMETRIE_EVENT_VALUES = {
    NEWSLETTER_ORIGIN_CREATION: "card creation",
    NEWSLETTER_ORIGIN_CARD_LINK: "card link",
    NEWSLETTER_ORIGIN_COMM_PREF: "communication preferences",
    NEWSLETTER_NAME_MOI: "moi",
    NEWSLETTER_NAME_PARTNERS: "moi partners",
    NEWSLETTER_NAME_SURVEYS: "moi surveys",
    CARD_LINK_INTENT_STEP_1: "1/3",
    CARD_LINK_INTENT_STEP_2: "2/3",
    CARD_LINK_INTENT_STEP_3: "3/3",
    CARD_LINK: "card_link",
};

export const CREATE_CARD = "3";